import * as RadixTooltip from "@radix-ui/react-tooltip";

type Props = RadixTooltip.TooltipProps;

export const Tooltip = RadixTooltip.Root;
export type { Props as TooltipProps };
